// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c5eb4c8c2b6476e4","5285":"52b8bd2e5e939920"}[chunkId] + ".css";
};